import { Component, Input, OnInit } from '@angular/core';
import { IonNav } from '@ionic/angular';
import { RepayPage } from '../repay.page';
import { RepayAchPage } from '../repay-ach/repay-ach.page';
import { RepayDigitalWalletPage } from '../repay-digital-wallet/repay-digital-wallet.page';
import { DdConsentFormPage } from '../../../../payment-plan/dd-consent-form/dd-consent-form.page';
import { CaseService } from 'src/app/services/case.service';

interface PaymentMethod {
  title: string;
  type: string;
  icon: string;
  src?: string;
}

@Component({
  selector: 'app-repay-method',
  templateUrl: './repay-method.page.html',
  styleUrls: ['./repay-method.page.scss'],
})
export class RepayMethodPage implements OnInit {
  @Input() caseId;
  @Input() totalOutstandingWithSymbol;
  @Input() caseDetails;
  @Input() debtorDetails;
  @Input() amount;
  @Input() responseData;
  @Input() caseData;

  paymentMethods: PaymentMethod[] = [
    {
      title: 'Card Payment',
      type: 'card',
      icon: 'card-outline'
    },
    {
      title: 'ACH Payment',
      type: 'ach',
      icon: 'card-outline',
      src: 'assets/icon/ach2.svg'
    },
    {
      title: 'Google Pay',
      type: 'googlepay',
      icon: 'logo-google'
    },
    {
      title: 'Apple Pay',
      type: 'applepay',
      icon: 'logo-apple'
    },
    {
      title: 'PayPal',
      type: 'paypal',
      icon: 'logo-paypal'
    },
    {
      title: 'Venmo',
      type: 'venmo',
      icon: 'logo-venmo'
    }
  ];

  constructor(private ionNav: IonNav, private caseService: CaseService) {}

  ngOnInit() {
    let portalSettings = JSON.parse(localStorage.getItem('portal_settings'));
    let payment_type = portalSettings?.payment_type?.repay || {};

    if (!payment_type.key) {
      this.paymentMethods = [];
      return;
    }

    if (payment_type.options?.length) {
      this.paymentMethods = this.paymentMethods.filter(method =>
        payment_type.options.includes(method.type)
      );
    }
     if (payment_type.option_labels && Object.keys(payment_type.option_labels).length) {
      this.paymentMethods = this.paymentMethods.map(method => ({
        ...method,
        title: payment_type.option_labels[method.type] ?? method.title
      }));
    }
  }

  handleMethodClick(method: PaymentMethod) {
    const commonParams = {
      amount: this.amount,
      caseId: this.caseId,
      totalOutstandingWithSymbol: this.totalOutstandingWithSymbol,
      debtorDetails: this.debtorDetails,
      caseDetails: this.caseDetails,
      responseData: this.responseData
    };

    switch (method.type) {
      case 'card':
        this.ionNav.push(RepayPage, commonParams);
        break;
      case 'ach':
        if (this.caseService.isDdConsentFormEnabled()) {
          this.ionNav.push(DdConsentFormPage, {
            caseData: this.caseData || this.caseDetails,
            debtorDetails: this.debtorDetails,
            amount: this.amount,
          });
          return;
        }
        this.ionNav.push(RepayAchPage, commonParams);
        break;
      case 'googlepay':
      case 'applepay':
      case 'paypal':
      case 'venmo':
        this.ionNav.push(RepayDigitalWalletPage, {
          ...commonParams,
          paymentMethod: method.type
        });
        break;
    }
  }

  dismiss() {
    this.ionNav.pop();
  }
}